/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-bind */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ApiService from 'Services/ApiService';
import TranslationUtils from 'Utils/TranslationUtils';

import ExistingCustomerVettingPage from '../components/ExistingCustomerVettingPage';
import { trackEvent } from '../utils';
import { getUsecaseCategoryById, getUsecaseSubCategoryById } from '../../../Utils/GenericUtils';

function ExistingCustomerVettingContainer({ history, product }) {
  // FIXME: Add redux here!!
  // const [_, dispatch] = useStateValue();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function onFormSubmit({
    firstName,
    lastName,
    company,
    phone,
    country,
    seatsNumber,
    usecaseCategory,
    usecaseSubCategory,
    customUsecase,
    captcha,
    agreeToTerms,
  }) {
    trackEvent('submit', '');
    setLoading(true);

    try {
      const usecaseCategoryObject = getUsecaseCategoryById(usecaseCategory);
      const usecaseSubCategoryObject = getUsecaseSubCategoryById(usecaseCategory, usecaseSubCategory);

      const resp = await ApiService.existingCustomerVetting({
        first_name: firstName,
        last_name: lastName,
        agree_to_terms: agreeToTerms,
        company,
        phone,
        country,
        product,
        recaptcha: captcha,
        use_case_code: usecaseSubCategory ? usecaseSubCategoryObject?.code : usecaseCategoryObject?.code,
        seats_number: seatsNumber || 1,
        job: ' ',
        use_case_category_text: TranslationUtils.getText(usecaseCategoryObject?.text_key, 'en') || null,
        use_case_sub_category_text: TranslationUtils.getText(usecaseSubCategoryObject?.text_key, 'en') || null,
        custom_use_case: customUsecase || null,
        use_case_category_text_key: usecaseCategoryObject?.text_key,
        use_case_sub_category_text_key: usecaseSubCategoryObject?.text_key,
      });
    } catch (e) {
      const data = e?.response?.data;
      if (data?.url) {
        window.location.replace(data.url);
      } else {
        window.location.reload();
      }
    }
  }

  return (
    <ExistingCustomerVettingPage
      product={product}
      user={window.__INITIAL_STATE.user}
      onSubmit={onFormSubmit}
      error={error}
      isLoading={isLoading}
    />
  );
}

ExistingCustomerVettingContainer.propTypes = {
  history: PropTypes.object,
  product: PropTypes.string,
};

export default ExistingCustomerVettingContainer;
